var _defs, _path, _path2, _path3, _rect, _rect2, _rect3, _rect4, _path4;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgPartners = function SvgPartners(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 250 250"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".Partners_svg__a08ccf3a-004e-4342-9a97-9bc280db96e3{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:5px}"))), /*#__PURE__*/React.createElement("g", {
    id: "Partners_svg__a3b66809-7ed0-4beb-89a3-143a6e43d2dd",
    "data-name": "Partners"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none"
    },
    d: "M0 0h250v250H0z"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "Partners_svg__a08ccf3a-004e-4342-9a97-9bc280db96e3",
    d: "m80.84 143.34-22.34-12.9a4.28 4.28 0 0 1-1.56-5.84l21.22-36.76a17.09 17.09 0 0 1 23.33-6.25l5 2.86M123.28 94.16l9.03 5.22 19.86 11.47-.02.04M94.23 151.07l-.06-.04"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "Partners_svg__a08ccf3a-004e-4342-9a97-9bc280db96e3",
    d: "m144 124.33 39.64 23a4.27 4.27 0 0 0 5.83-1.56l3.62-6.27a4.28 4.28 0 0 0-1.56-5.84l-59.22-34.28"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "Partners_svg__a08ccf3a-004e-4342-9a97-9bc280db96e3",
    d: "m135 137.61 38.62 22a4.27 4.27 0 0 0 5.84-1.57l3.62-6.27a4.26 4.26 0 0 0-1.57-5.83l-37-21.39M126.35 151l35 20.68a4.27 4.27 0 0 0 5.83-1.56l3.62-6.27a4.28 4.28 0 0 0-1.56-5.84l-34.6-19.72M126.22 151.18l26.1 15.57a4.27 4.27 0 0 1 1.56 5.83l-3.46 6a4.27 4.27 0 0 1-5.83 1.56l-10.24-5.91"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "Partners_svg__a08ccf3a-004e-4342-9a97-9bc280db96e3",
    x: 77.2,
    y: 139.47,
    width: 20.67,
    height: 15.46,
    rx: 5,
    transform: "rotate(-60 87.538 147.2)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "Partners_svg__a08ccf3a-004e-4342-9a97-9bc280db96e3",
    x: 90.53,
    y: 147.17,
    width: 20.67,
    height: 15.46,
    rx: 5,
    transform: "rotate(-60 100.875 154.9)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "Partners_svg__a08ccf3a-004e-4342-9a97-9bc280db96e3",
    x: 103.93,
    y: 154.9,
    width: 20.67,
    height: 15.46,
    rx: 5,
    transform: "rotate(-60 114.263 162.63)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "Partners_svg__a08ccf3a-004e-4342-9a97-9bc280db96e3",
    x: 117.32,
    y: 162.63,
    width: 20.67,
    height: 15.46,
    rx: 5,
    transform: "rotate(-60 127.652 170.36)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "Partners_svg__a08ccf3a-004e-4342-9a97-9bc280db96e3",
    d: "M152.42 129.21h-.01M175.53 124.33h2.4V94a17.08 17.08 0 0 0-17.07-17.08H138a16 16 0 0 1-8.16-2.45h0L120.32 69a4.27 4.27 0 0 0-5.83 1.57l-8 13.93-4.88 8.46a4.28 4.28 0 0 0 1.56 5.84l9.43 5.45a4.28 4.28 0 0 0 5.83-1.57l4.9-8.47M147.11 107.08l8.74-5.51"
  }))));
};

export default SvgPartners;